(function($) {

	$(".c-specifications__group-title").click(function(){

		$(this).parent().toggleClass("open-group");

	});

})(jQuery);
